/** @format */
import { createMachine } from 'xstate';

export enum CreateAlertMachineAction {
    SUBMIT = 'submit',
}

export enum CreateAlertMachineState {
    FORM = 'form',
    CONFIRMATION = 'confirmation',
}

export const createAlertMachine = createMachine({
    predictableActionArguments: true,
    id: 'create-alert-machine',
    initial: CreateAlertMachineState.FORM,
    states: {
        [CreateAlertMachineState.FORM]: {
            on: {
                [CreateAlertMachineAction.SUBMIT]:
                    CreateAlertMachineState.CONFIRMATION,
            },
        },
        [CreateAlertMachineState.CONFIRMATION]: {},
    },
});
